/**
 * Layout breakpoints for My TXT (local — do not import @urbantxt/styles).
 * Keep in sync with src/styles/_breakpoints.scss.
 */
export const BREAKPOINTS = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1408,
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;

export type BreakpointName = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
